import { CmsProtectionCardBanner } from '../cms/cms-protection-card-banner.interface';
import { CmsRegisterAnotherAppliancePanel } from '../cms/cms-register-another-appliance-panel.interface';
import { CmsRegistrationRoot } from '../cms/cms-registration-root.interface';
import { CmsInstallationInstructionPanel } from './cms-installation-instruction-panel.interface';
import { CmsPaperlessInstructionPanel } from './cms-paperless-instruction-panel.interface';
import { CmsRegistrationSummaryPanel } from './cms-registration-summary-panel.interface';

export type CmsRegistrationConfirmationPage = CmsRegistrationRoot &
  CmsInstallationInstructionPanel &
  CmsPaperlessInstructionPanel &
  CmsProtectionCardBanner &
  CmsRegisterAnotherAppliancePanel &
  CmsRegistrationSummaryPanel;
